module.exports = __webpack_public_path__ + "img/banner2_m.09a361fa.jpg";